export default "__VITE_ASSET__510985ba__"